// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("Poppins-ExtraBoldItalic.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("Poppins-ExtraBoldItalic.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("Poppins-ExtraBold.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("Poppins-ExtraBold.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("Poppins-BoldItalic.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("Poppins-BoldItalic.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("Poppins-ExtraLight.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("Poppins-ExtraLight.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("Poppins-ExtraLightItalic.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("Poppins-ExtraLightItalic.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_10___ = new URL("Poppins-Italic.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_11___ = new URL("Poppins-Italic.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_12___ = new URL("Poppins-Light.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_13___ = new URL("Poppins-Light.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_14___ = new URL("Poppins-Medium.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_15___ = new URL("Poppins-Medium.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_16___ = new URL("Poppins-MediumItalic.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_17___ = new URL("Poppins-MediumItalic.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_18___ = new URL("Poppins-LightItalic.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_19___ = new URL("Poppins-LightItalic.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_20___ = new URL("Poppins-SemiBoldItalic.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_21___ = new URL("Poppins-SemiBoldItalic.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_22___ = new URL("Poppins-SemiBold.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_23___ = new URL("Poppins-SemiBold.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_24___ = new URL("Poppins-Regular.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_25___ = new URL("Poppins-Regular.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_26___ = new URL("Poppins-ThinItalic.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_27___ = new URL("Poppins-ThinItalic.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_28___ = new URL("Poppins-Thin.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_29___ = new URL("Poppins-Thin.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_30___ = new URL("Poppins-Black.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_31___ = new URL("Poppins-Black.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_32___ = new URL("Poppins-BlackItalic.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_33___ = new URL("Poppins-BlackItalic.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_34___ = new URL("Poppins-Bold.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_35___ = new URL("Poppins-Bold.woff", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___);
var ___CSS_LOADER_URL_REPLACEMENT_10___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___);
var ___CSS_LOADER_URL_REPLACEMENT_11___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_11___);
var ___CSS_LOADER_URL_REPLACEMENT_12___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_12___);
var ___CSS_LOADER_URL_REPLACEMENT_13___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_13___);
var ___CSS_LOADER_URL_REPLACEMENT_14___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_14___);
var ___CSS_LOADER_URL_REPLACEMENT_15___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_15___);
var ___CSS_LOADER_URL_REPLACEMENT_16___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_16___);
var ___CSS_LOADER_URL_REPLACEMENT_17___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_17___);
var ___CSS_LOADER_URL_REPLACEMENT_18___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_18___);
var ___CSS_LOADER_URL_REPLACEMENT_19___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_19___);
var ___CSS_LOADER_URL_REPLACEMENT_20___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_20___);
var ___CSS_LOADER_URL_REPLACEMENT_21___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_21___);
var ___CSS_LOADER_URL_REPLACEMENT_22___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_22___);
var ___CSS_LOADER_URL_REPLACEMENT_23___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_23___);
var ___CSS_LOADER_URL_REPLACEMENT_24___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_24___);
var ___CSS_LOADER_URL_REPLACEMENT_25___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_25___);
var ___CSS_LOADER_URL_REPLACEMENT_26___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_26___);
var ___CSS_LOADER_URL_REPLACEMENT_27___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_27___);
var ___CSS_LOADER_URL_REPLACEMENT_28___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_28___);
var ___CSS_LOADER_URL_REPLACEMENT_29___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_29___);
var ___CSS_LOADER_URL_REPLACEMENT_30___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_30___);
var ___CSS_LOADER_URL_REPLACEMENT_31___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_31___);
var ___CSS_LOADER_URL_REPLACEMENT_32___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_32___);
var ___CSS_LOADER_URL_REPLACEMENT_33___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_33___);
var ___CSS_LOADER_URL_REPLACEMENT_34___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_34___);
var ___CSS_LOADER_URL_REPLACEMENT_35___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_35___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
    font-family: 'Poppins';
    src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format('woff2'),
        url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format('woff');
    font-weight: bold;
    font-style: italic;
    font-display: swap;
}

@font-face {
    font-family: 'Poppins';
    src: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format('woff2'),
        url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format('woff');
    font-weight: bold;
    font-style: normal;
    font-display: swap;
}

@font-face {
    font-family: 'Poppins';
    src: url(${___CSS_LOADER_URL_REPLACEMENT_4___}) format('woff2'),
        url(${___CSS_LOADER_URL_REPLACEMENT_5___}) format('woff');
    font-weight: bold;
    font-style: italic;
    font-display: swap;
}

@font-face {
    font-family: 'Poppins';
    src: url(${___CSS_LOADER_URL_REPLACEMENT_6___}) format('woff2'),
        url(${___CSS_LOADER_URL_REPLACEMENT_7___}) format('woff');
    font-weight: 200;
    font-style: normal;
    font-display: swap;
}

@font-face {
    font-family: 'Poppins';
    src: url(${___CSS_LOADER_URL_REPLACEMENT_8___}) format('woff2'),
        url(${___CSS_LOADER_URL_REPLACEMENT_9___}) format('woff');
    font-weight: 200;
    font-style: italic;
    font-display: swap;
}

@font-face {
    font-family: 'Poppins';
    src: url(${___CSS_LOADER_URL_REPLACEMENT_10___}) format('woff2'),
        url(${___CSS_LOADER_URL_REPLACEMENT_11___}) format('woff');
    font-weight: normal;
    font-style: italic;
    font-display: swap;
}

@font-face {
    font-family: 'Poppins';
    src: url(${___CSS_LOADER_URL_REPLACEMENT_12___}) format('woff2'),
        url(${___CSS_LOADER_URL_REPLACEMENT_13___}) format('woff');
    font-weight: 300;
    font-style: normal;
    font-display: swap;
}

@font-face {
    font-family: 'Poppins';
    src: url(${___CSS_LOADER_URL_REPLACEMENT_14___}) format('woff2'),
        url(${___CSS_LOADER_URL_REPLACEMENT_15___}) format('woff');
    font-weight: 500;
    font-style: normal;
    font-display: swap;
}

@font-face {
    font-family: 'Poppins';
    src: url(${___CSS_LOADER_URL_REPLACEMENT_16___}) format('woff2'),
        url(${___CSS_LOADER_URL_REPLACEMENT_17___}) format('woff');
    font-weight: 500;
    font-style: italic;
    font-display: swap;
}

@font-face {
    font-family: 'Poppins';
    src: url(${___CSS_LOADER_URL_REPLACEMENT_18___}) format('woff2'),
        url(${___CSS_LOADER_URL_REPLACEMENT_19___}) format('woff');
    font-weight: 300;
    font-style: italic;
    font-display: swap;
}

@font-face {
    font-family: 'Poppins';
    src: url(${___CSS_LOADER_URL_REPLACEMENT_20___}) format('woff2'),
        url(${___CSS_LOADER_URL_REPLACEMENT_21___}) format('woff');
    font-weight: 600;
    font-style: italic;
    font-display: swap;
}

@font-face {
    font-family: 'Poppins';
    src: url(${___CSS_LOADER_URL_REPLACEMENT_22___}) format('woff2'),
        url(${___CSS_LOADER_URL_REPLACEMENT_23___}) format('woff');
    font-weight: 600;
    font-style: normal;
    font-display: swap;
}

@font-face {
    font-family: 'Poppins';
    src: url(${___CSS_LOADER_URL_REPLACEMENT_24___}) format('woff2'),
        url(${___CSS_LOADER_URL_REPLACEMENT_25___}) format('woff');
    font-weight: normal;
    font-style: normal;
    font-display: swap;
}

@font-face {
    font-family: 'Poppins';
    src: url(${___CSS_LOADER_URL_REPLACEMENT_26___}) format('woff2'),
        url(${___CSS_LOADER_URL_REPLACEMENT_27___}) format('woff');
    font-weight: 100;
    font-style: italic;
    font-display: swap;
}

@font-face {
    font-family: 'Poppins';
    src: url(${___CSS_LOADER_URL_REPLACEMENT_28___}) format('woff2'),
        url(${___CSS_LOADER_URL_REPLACEMENT_29___}) format('woff');
    font-weight: 100;
    font-style: normal;
    font-display: swap;
}

@font-face {
    font-family: 'Poppins';
    src: url(${___CSS_LOADER_URL_REPLACEMENT_30___}) format('woff2'),
        url(${___CSS_LOADER_URL_REPLACEMENT_31___}) format('woff');
    font-weight: 900;
    font-style: normal;
    font-display: swap;
}

@font-face {
    font-family: 'Poppins';
    src: url(${___CSS_LOADER_URL_REPLACEMENT_32___}) format('woff2'),
        url(${___CSS_LOADER_URL_REPLACEMENT_33___}) format('woff');
    font-weight: 900;
    font-style: italic;
    font-display: swap;
}

@font-face {
    font-family: 'Poppins';
    src: url(${___CSS_LOADER_URL_REPLACEMENT_34___}) format('woff2'),
        url(${___CSS_LOADER_URL_REPLACEMENT_35___}) format('woff');
    font-weight: bold;
    font-style: normal;
    font-display: swap;
}

`, "",{"version":3,"sources":["webpack://./src/assets/Fonts/Poppins/stylesheet.css"],"names":[],"mappings":"AAAA;IACI,sBAAsB;IACtB;8DACsD;IACtD,iBAAiB;IACjB,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,sBAAsB;IACtB;8DACgD;IAChD,iBAAiB;IACjB,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,sBAAsB;IACtB;8DACiD;IACjD,iBAAiB;IACjB,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,sBAAsB;IACtB;8DACiD;IACjD,gBAAgB;IAChB,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,sBAAsB;IACtB;8DACuD;IACvD,gBAAgB;IAChB,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,sBAAsB;IACtB;+DAC6C;IAC7C,mBAAmB;IACnB,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,sBAAsB;IACtB;+DAC4C;IAC5C,gBAAgB;IAChB,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,sBAAsB;IACtB;+DAC6C;IAC7C,gBAAgB;IAChB,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,sBAAsB;IACtB;+DACmD;IACnD,gBAAgB;IAChB,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,sBAAsB;IACtB;+DACkD;IAClD,gBAAgB;IAChB,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,sBAAsB;IACtB;+DACqD;IACrD,gBAAgB;IAChB,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,sBAAsB;IACtB;+DAC+C;IAC/C,gBAAgB;IAChB,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,sBAAsB;IACtB;+DAC8C;IAC9C,mBAAmB;IACnB,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,sBAAsB;IACtB;+DACiD;IACjD,gBAAgB;IAChB,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,sBAAsB;IACtB;+DAC2C;IAC3C,gBAAgB;IAChB,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,sBAAsB;IACtB;+DAC4C;IAC5C,gBAAgB;IAChB,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,sBAAsB;IACtB;+DACkD;IAClD,gBAAgB;IAChB,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,sBAAsB;IACtB;+DAC2C;IAC3C,iBAAiB;IACjB,kBAAkB;IAClB,kBAAkB;AACtB","sourcesContent":["@font-face {\n    font-family: 'Poppins';\n    src: url('Poppins-ExtraBoldItalic.woff2') format('woff2'),\n        url('Poppins-ExtraBoldItalic.woff') format('woff');\n    font-weight: bold;\n    font-style: italic;\n    font-display: swap;\n}\n\n@font-face {\n    font-family: 'Poppins';\n    src: url('Poppins-ExtraBold.woff2') format('woff2'),\n        url('Poppins-ExtraBold.woff') format('woff');\n    font-weight: bold;\n    font-style: normal;\n    font-display: swap;\n}\n\n@font-face {\n    font-family: 'Poppins';\n    src: url('Poppins-BoldItalic.woff2') format('woff2'),\n        url('Poppins-BoldItalic.woff') format('woff');\n    font-weight: bold;\n    font-style: italic;\n    font-display: swap;\n}\n\n@font-face {\n    font-family: 'Poppins';\n    src: url('Poppins-ExtraLight.woff2') format('woff2'),\n        url('Poppins-ExtraLight.woff') format('woff');\n    font-weight: 200;\n    font-style: normal;\n    font-display: swap;\n}\n\n@font-face {\n    font-family: 'Poppins';\n    src: url('Poppins-ExtraLightItalic.woff2') format('woff2'),\n        url('Poppins-ExtraLightItalic.woff') format('woff');\n    font-weight: 200;\n    font-style: italic;\n    font-display: swap;\n}\n\n@font-face {\n    font-family: 'Poppins';\n    src: url('Poppins-Italic.woff2') format('woff2'),\n        url('Poppins-Italic.woff') format('woff');\n    font-weight: normal;\n    font-style: italic;\n    font-display: swap;\n}\n\n@font-face {\n    font-family: 'Poppins';\n    src: url('Poppins-Light.woff2') format('woff2'),\n        url('Poppins-Light.woff') format('woff');\n    font-weight: 300;\n    font-style: normal;\n    font-display: swap;\n}\n\n@font-face {\n    font-family: 'Poppins';\n    src: url('Poppins-Medium.woff2') format('woff2'),\n        url('Poppins-Medium.woff') format('woff');\n    font-weight: 500;\n    font-style: normal;\n    font-display: swap;\n}\n\n@font-face {\n    font-family: 'Poppins';\n    src: url('Poppins-MediumItalic.woff2') format('woff2'),\n        url('Poppins-MediumItalic.woff') format('woff');\n    font-weight: 500;\n    font-style: italic;\n    font-display: swap;\n}\n\n@font-face {\n    font-family: 'Poppins';\n    src: url('Poppins-LightItalic.woff2') format('woff2'),\n        url('Poppins-LightItalic.woff') format('woff');\n    font-weight: 300;\n    font-style: italic;\n    font-display: swap;\n}\n\n@font-face {\n    font-family: 'Poppins';\n    src: url('Poppins-SemiBoldItalic.woff2') format('woff2'),\n        url('Poppins-SemiBoldItalic.woff') format('woff');\n    font-weight: 600;\n    font-style: italic;\n    font-display: swap;\n}\n\n@font-face {\n    font-family: 'Poppins';\n    src: url('Poppins-SemiBold.woff2') format('woff2'),\n        url('Poppins-SemiBold.woff') format('woff');\n    font-weight: 600;\n    font-style: normal;\n    font-display: swap;\n}\n\n@font-face {\n    font-family: 'Poppins';\n    src: url('Poppins-Regular.woff2') format('woff2'),\n        url('Poppins-Regular.woff') format('woff');\n    font-weight: normal;\n    font-style: normal;\n    font-display: swap;\n}\n\n@font-face {\n    font-family: 'Poppins';\n    src: url('Poppins-ThinItalic.woff2') format('woff2'),\n        url('Poppins-ThinItalic.woff') format('woff');\n    font-weight: 100;\n    font-style: italic;\n    font-display: swap;\n}\n\n@font-face {\n    font-family: 'Poppins';\n    src: url('Poppins-Thin.woff2') format('woff2'),\n        url('Poppins-Thin.woff') format('woff');\n    font-weight: 100;\n    font-style: normal;\n    font-display: swap;\n}\n\n@font-face {\n    font-family: 'Poppins';\n    src: url('Poppins-Black.woff2') format('woff2'),\n        url('Poppins-Black.woff') format('woff');\n    font-weight: 900;\n    font-style: normal;\n    font-display: swap;\n}\n\n@font-face {\n    font-family: 'Poppins';\n    src: url('Poppins-BlackItalic.woff2') format('woff2'),\n        url('Poppins-BlackItalic.woff') format('woff');\n    font-weight: 900;\n    font-style: italic;\n    font-display: swap;\n}\n\n@font-face {\n    font-family: 'Poppins';\n    src: url('Poppins-Bold.woff2') format('woff2'),\n        url('Poppins-Bold.woff') format('woff');\n    font-weight: bold;\n    font-style: normal;\n    font-display: swap;\n}\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
